export const IMPORT_EXPORT_DICOM_DETAILS_FILE_URI = '/files/MVision ImportExport UI DICOM De-identification Details.pdf';
export const SERVICE_AGREEMENT_FILE_URI = '/files/MVision Web Demo Service Agreement.pdf';
